const match = (param) => /^\d+$/.test(param);
export {
  match
};
